import React from "react";
import Navbar from "../Navbar/Navbar";
import Bredcom from "../Bredcom/Bredcom";
import Footer from "../Footer/Footer";
import { Link } from "react-router-dom";

function MarketingMenadzmentPEM() {
  return (
    <>
      <Navbar />
      <Bredcom title="Početna" subtitle="Marketing menadžment" />
      <div className="container mt-4 pt-40">
        <div className="row">
          <div className="col-md-8">
            <div className="content-container">
              <h2 className="section-title">Marketing menadžment</h2>
              <p>
                <strong>Studijski program:</strong> Poslovna ekonomija
              </p>
              <p>
                <strong>Naziv predmeta:</strong> Marketing Menadžment
              </p>
              <p>
                <strong>Nastavnik:</strong>
              </p>
              <p>
                <strong>Status predmeta:</strong> Obavezan
              </p>
              <p>
                <strong>Broj ECTS:</strong> 7
              </p>
              <p>
                <strong>Uslov:</strong> Marketing Menadžment
              </p>

              <h3>Cilj predmeta</h3>
              <p>
                Predmet MARKETING MENADŽMENT stavlja u dinamički kontekst
                planiranja organizovanja i kontrole znanja koje su studenti
                stekli kroz izučavanje Principa marketinga i specijalističkih
                disciplina. Ključni zadatak studenata je izrada detaljnog
                marketing plana za poslovni poduhvat. Tokom semestra studenti
                stiču znanja i veštine potrebne za razvoj marketing plana,
                uključujući analizu ciljeva i resursa kompanije, analizu ciljnog
                tržišta, konkurenata, eksternog okruženja (PEST), SWOT analizu,
                artikulisanje marketing ciljeva, elemente diferenciranja i
                pozicioniranja, kao i razvoj elemenata marketing
                strategija/taktika prema instrumentima marketing miksa. Tokom
                nastave i vežbi biće predstavljeni teorijski koncepti i njihova
                praktična aplikacija kroz primere i studije slučaja. Posebno
                vreme tokom nastave i vežbi biće posvećeno grupnom radu
                studenata u primeni stečenih znanja na konkretnom poslovnom
                poduhvatu. Studentima će biti predstavljeni i različiti oblici
                organizovanja marketing aktivnosti kao i adekvatni instrumenti
                kontrole.
              </p>

              <h3>Ishod predmeta</h3>
              <p>
                Izučavanjem nastavnog predmeta Marketing menadžment studenti
                stiču bazična znanja o: pristupima izborima ciljnog tržišta i
                ključnim veštinama pridobijanja, zadržavanja i povećanja broja
                lojalnih kupaca; značaju holističkog marketinga u procesu
                strategijskog prilagođavanja identifikovanim promenama u
                okruženju; uticaju marketing menadžmenta na podizanje
                profitabilnosti preduzeća; aktivnostima kreiranja, isporučivanja
                i komuniciranja vrednosti na području brendiranja.
              </p>

              <h3>Sadržaj predmeta</h3>
              <p>
                Uvodno predavanje marketing u XXI vijeku, priroda savremenog
                marketinga, planiranje marketing aktivnosti i faze marketing
                planiranja. Drugi dio bazira se na oblasti odlučivanje i odluke
                – šta je odluka, uslovi u kojima se odvija proces odlučivanja i
                vrste odluka kao i varijante oblika organizovanja marketing
                aktivnosti. Nakon dva kolokvijuma, nastava se bazira na
                strateškoj kontroli kao i kontroli prodaje kao podfunkcije
                marketinga.
              </p>

              <h3>Metode izvođenja nastave</h3>
              <p>
                Nastava je u skladu sa zahtjevima predmeta interaktivna. Težište
                je na razvijanju receptivne i automatizaciji reproduktivne
                sposobnosti uz pomoć različitih tipova vježbi i simulacije
                tipičnih poslovnih situacija i razgovora.
              </p>

              <h3 className="pt-20 pb-10">Plan rada</h3>
              <table className="table table-bordered ofpep-section">
                <thead>
                  <tr>
                    <th>Nedjelja</th>
                    <th>Fond časova</th>
                    <th>Sadržaj</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Pripremna</td>
                    <td>Upoznavanje, dogovor o radu i slično</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>I</td>
                    <td>3P + 2V</td>
                    <td>
                      Uvodno predavanje marketing u XXI vijeku, priroda
                      savremenog marketinga
                    </td>
                  </tr>
                  <tr>
                    <td>II</td>
                    <td>3P + 2V</td>
                    <td>
                      Internacionalizacija poslovanja preduzeća; elektronski
                      marketing
                    </td>
                  </tr>
                  <tr>
                    <td>III</td>
                    <td>3P + 2V</td>
                    <td>
                      Planiranje marketing aktivnosti; determinisanje marketing
                      planiranja
                    </td>
                  </tr>
                  <tr>
                    <td>IV</td>
                    <td>3P + 2V</td>
                    <td>
                      Postupak planiranja marketing aktivnosti – metodološki
                      aspekti. Prognoziranje i misija preduzeća, prognoziranje
                      tehnologije
                    </td>
                  </tr>
                  <tr>
                    <td>V</td>
                    <td>3P + 2V</td>
                    <td>Faze marketing planiranja</td>
                  </tr>
                  <tr>
                    <td>VI</td>
                    <td>Kolokvijum I</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>VII</td>
                    <td>3P + 2V</td>
                    <td>
                      Odlučivanje i odluke: šta je odluka, uslovi u kojima se
                      odvija proces odlučivanja; vrste odluka
                    </td>
                  </tr>
                  <tr>
                    <td>VIII</td>
                    <td>3P + 2V</td>
                    <td>
                      Teorijski pravci u izučavanju odlučivanja i područja
                      donošenja odluka u marketingu
                    </td>
                  </tr>
                  <tr>
                    <td>IX</td>
                    <td>3P + 2V</td>
                    <td>
                      Organizovanje marketing aktivnosti; pristup organizovanju
                      marketing aktivnosti i faktori organizovanja marketing
                      aktivnosti
                    </td>
                  </tr>
                  <tr>
                    <td>X</td>
                    <td>3P + 2V</td>
                    <td>Varijante oblika organizovanja marketing aktivnosti</td>
                  </tr>
                  <tr>
                    <td>XI</td>
                    <td>3P + 2V</td>
                    <td>
                      Karakteristike uspješnog organizovanja marketing
                      aktivnosti
                    </td>
                  </tr>
                  <tr>
                    <td>XII</td>
                    <td>Kolokvijum II</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>XIII</td>
                    <td>3P + 2V</td>
                    <td>
                      Kontrola marketing aktivnosti: mjesto i uloga kontrole u
                      procesu upravljanja marketingom
                    </td>
                  </tr>
                  <tr>
                    <td>XIV</td>
                    <td>3P + 2V</td>
                    <td>Strateška kontrola – preispitivanje marketinga</td>
                  </tr>
                  <tr>
                    <td>XV</td>
                    <td>3P + 2V</td>
                    <td>
                      Kontrola prodaje kao podfunkcije marketinga; kontrola
                      istraživanja tržišta
                    </td>
                  </tr>
                  <tr>
                    <td>XVI</td>
                    <td>Sveobuhvatni ispit</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>XVII</td>
                    <td>Ovjera semestra i upis ocjena</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>XVIII</td>
                    <td>Popravni ispitni rok</td>
                    <td></td>
                  </tr>
                </tbody>
              </table>

              <h3 className="pt-20 pb-10">Obaveze studenata</h3>
              <table className="table table-bordered ofpep-section">
                <thead>
                  <tr>
                    <th>Obaveze studenata</th>
                    <th>U toku nastave</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Obaveze studenata u toku nastave</td>
                    <td>
                      Studenti su obavezni da pohađaju nastavu, vežbe i ispite
                    </td>
                  </tr>
                  <tr>
                    <td>Konsultacije</td>
                    <td>
                      Konsultacije se održavaju sa nastavnikom i saradnikom
                      poslije časova
                    </td>
                  </tr>
                  <tr>
                    <td>Opterećenje studenata u časovima</td>
                    <td>
                      <table className="table table-bordered ofpep-section">
                        <thead>
                          <tr>
                            <th>Nedjeljno</th>
                            <th>U semestru</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>Ukupno: 5 č / 3.45h</td>
                            <td>Ukupno: 90 č</td>
                          </tr>
                          <tr>
                            <td>Predavanja: 3 č / 2.15h</td>
                            <td>Nastava + završni ispit: 65 č</td>
                          </tr>
                          <tr>
                            <td>Vježbe: 2 č / 1.3h</td>
                            <td>Priprema i ovjera semestra: 10 č</td>
                          </tr>
                          <tr>
                            <td>Individualni rad:</td>
                            <td>Priprema i polaganje popravnog ispita: 15 č</td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                </tbody>
              </table>

              <h3 className="pt-20 pb-10">Ocjenjivanje</h3>
              <table className="table table-bordered ofpep-section">
                <thead>
                  <tr>
                    <th>Ocjena</th>
                    <th>Broj poena</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>A(odličan)</td>
                    <td>91-100</td>
                  </tr>
                  <tr>
                    <td>B(vrlo dobar)</td>
                    <td>81-90</td>
                  </tr>
                  <tr>
                    <td>C(dobar)</td>
                    <td>71-80</td>
                  </tr>
                  <tr>
                    <td>D(zadovoljava)</td>
                    <td>61-70</td>
                  </tr>
                  <tr>
                    <td>E(dovoljan)</td>
                    <td>51-60</td>
                  </tr>
                  <tr>
                    <td>F(nedovoljan)</td>
                    <td>0-50</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div className="col-md-4 pt-10">
            <aside className="sidebar-widget">
              <section
                id="custom_html-5"
                className="widget_text widget widget_custom_html"
              >
                <h2 className="widget-title">Zapratite nas</h2>
                <div className="textwidget custom-html-widget">
                  <div className="widget-social">
                    <a
                      href="https://www.facebook.com/fpebar.me"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-facebook-f" />
                    </a>
                    <a
                      href="https://www.instagram.com/fpepbar/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-instagram" />
                    </a>
                    <a
                      href="https://www.youtube.com/@fpepbar"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-youtube" />
                    </a>
                    <a
                      href="https://www.tiktok.com/@fpepbar"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Follow us on Tiktok"
                      title="Tiktok"
                    >
                      <i className="fab fa-tiktok" />
                    </a>
                    <a
                      href="https://www.linkedin.com/school/fpepbar/"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Follow us on LinkedIn"
                      title="LinkedIn"
                    >
                      <i className="fab fa-linkedin-in" />
                    </a>
                  </div>
                </div>
              </section>
              <section id="categories-1" className="widget widget_categories">
                <h2 className="widget-title">Korisni linkovi</h2>
                <ul>
                  <li className="cat-item cat-item-16">
                    <Link to="/o-fpep">O Fakultetu</Link>
                  </li>
                  <li className="cat-item cat-item-23">
                    <Link to="/akreditacija-fpep">Akreditacija FPEP-a</Link>
                  </li>
                  <li className="cat-item cat-item-18">
                    <Link to="/upis">Upis</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/cijene-studija">Školarina</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/erasmus">Erasmus+</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/projekti">Projekti</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/dom-studenata">Dom studenata</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/galerija">Galerija</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/novosti">Novosti</Link>
                  </li>
                </ul>
              </section>
              <section
                id="recent-posts-4"
                className="widget widget_recent_entries"
              >
                <h2 className="widget-title">Studijski programi</h2>
                <ul>
                  <li>
                    <span className="post-date">
                      <strong>Osnovne studije</strong> <br />
                    </span>
                    <Link to="/racunovodstvo-finansije-i-bankarstvo">
                      Računovodstvo, bankarstvo i finansije
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/menadzment">
                      Menadžment
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/pravo-osnovne">
                      Pravo
                      <br />
                    </Link>
                  </li>
                  <li>
                    <span className="post-date">
                      <strong>Master studije</strong> <br />
                    </span>
                    <Link to="/poslovna-ekonomija">
                      Poslovna ekonomija
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/ekonomija-javnog-sektora">
                      Ekonomija javnog sektora
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/pravo-master">
                      Pravo
                      <br />
                    </Link>
                  </li>
                </ul>
              </section>
            </aside>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default MarketingMenadzmentPEM;
